module.exports = __webpack_public_path__ + "static/media/discountTop.10702c11.png";